"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signEIP2612Permit = void 0;
var typings_1 = require("../typings");
exports.signEIP2612Permit = function (signer, token, owner, spender, value, deadline, nonce, chainId, version) {
    if (version === void 0) { version = '1'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var message, domain, types, signature, parsedVRS;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    message = {
                        owner: owner,
                        spender: spender,
                        value: value.toString(),
                        nonce: nonce.toString(),
                        deadline: deadline.toString(),
                    };
                    return [4 /*yield*/, _getDomain(signer, token, chainId, version)];
                case 1:
                    domain = _a.sent();
                    types = {
                        Permit: [
                            { name: 'owner', type: 'address' },
                            { name: 'spender', type: 'address' },
                            { name: 'value', type: 'uint256' },
                            { name: 'nonce', type: 'uint256' },
                            { name: 'deadline', type: 'uint256' },
                        ],
                    };
                    return [4 /*yield*/, signer._signTypedData(domain, types, message)];
                case 2:
                    signature = _a.sent();
                    parsedVRS = _parseVRS(signature);
                    return [2 /*return*/, Object.assign(Object.assign({}, parsedVRS), message)];
            }
        });
    });
};
var _getDomain = function (signer, token, chainId, version) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenContract, tokenAddress, name, domain;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tokenContract = typings_1.BaseERC20Factory.connect(token, signer);
                tokenAddress = token;
                return [4 /*yield*/, tokenContract.name()];
            case 1:
                name = _a.sent();
                domain = {
                    name: name,
                    version: version,
                    chainId: chainId,
                    verifyingContract: tokenAddress,
                };
                return [2 /*return*/, domain];
        }
    });
}); };
var _parseVRS = function (sig) {
    return {
        r: sig.slice(0, 66),
        s: '0x' + sig.slice(66, 130),
        v: parseInt(sig.slice(130, 132), 16),
    };
};
